import { Component, OnInit } from '@angular/core';
import {Apikeys} from "../../../../../_models/apikeys";
import {Subject} from "rxjs";
import {Fraccionamiento} from "../../../../../_models/fraccionamiento";
import {NavigationExtras, Router} from "@angular/router";
import {FraccionamientoService} from "../fraccionamiento.service";
import {MatDialog} from "@angular/material/dialog";
import {PageHeaderDataService} from "../../../../../shared/services/page-header-data.service";
import {FormBuilder} from "@angular/forms";
import {PageHeaderData} from "../../../../../shared/components/forms-header/page-header-data";
import {takeUntil} from "rxjs/operators";
import {PageEvent} from "@angular/material/paginator";
import {SnackbarService} from "../../../../../services/snackbar-service.service";
import {JsonCsvService} from "../../../reporte/json-csv.service";
import {PersonaListaEntidad} from "../../../persona/persona-detalle/persona-lista-entidad";

@Component({
  selector: 'app-list-fraccionamiento',
  templateUrl: './list-fraccionamiento.component.html',
  styleUrls: ['./list-fraccionamiento.component.scss']
})
export class ListFraccionamientoComponent implements OnInit {
  displayedColumns = ['fechaSolicitud','comercio','nombre', 'apellido', 'numeroSolicitud', 'montoSolicitado', 'plazoMeses', 'importeCuota', 'estadoSolicitud','acciones'];
  dataSource: Array<Fraccionamiento> = [];
  estadoList: any[] = [];
  filter: any = {
    nombre: '',
    apellido:'',
    comercio: '',
    codigoCliente: '',
    estadoSolicitudId: '',
    fechaSolicitud: '',
    entidad: false,
    cantidadPagina: 10,
    pagina: 1
  };
  panelOpenState = true; // muestra/oculta el filtro
  paginacion: any = {
    cantidad: 0,
    por_pagina: 10,
    pagina: 1,
    total: 0,
  };
  filterTimer: any;
  formFilter = null;
  unsubscribe$: Subject<any> = new Subject();

  constructor(
    public router: Router,
    public  service: FraccionamientoService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService,
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private csvService: JsonCsvService,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    if (this.router.url === '/procesadora/fraccionamiento') {
      this.filter.entidad = false; // no filtrar por entidad
      this.headerDataService.setHeaderData(new PageHeaderData('Fraccionamiento', 'procesadora/fraccionamiento', false, false));
    }
    if (this.router.url === '/entidad/fraccionamiento') {
      this.filter.entidad = true; // no filtrar por entidad
      this.headerDataService.setHeaderData(new PageHeaderData('Fraccionamiento', 'entidad/fraccionamiento', false, false));
    }

    this.obtenerListaEstadoSolicitudCredito();
    this.obtenerlistaCreditos();
  }

  private buildForm() {
    this.formFilter = this.fb.group({
      nombre: [''],
      apellido: [''],
      comercio: [''],
      codigoCliente: [''],
      estadoSolicitudId: [''],
      fechaSolicitud: [''],
    });
    // se enlazan filtros con formulario reactivo
    this.formFilter.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe( data => {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {

        let fechaHora: Date;
        let fFechaHora = '';
        if (data.fechaSolicitud) {
          fechaHora = new Date(data.fechaSolicitud);
          fFechaHora = (fechaHora.getMonth() < 9 ? '0' : '-') + (fechaHora.getMonth()+1) + (fechaHora.getDate() < 10 ? '-0' : '-')  + fechaHora.getDate() +'-'+ fechaHora.getFullYear();
        }

        this.filter.nombre = data.nombre;
        this.filter.apellido = data.apellido;
        this.filter.comercio = data.comercio;
        this.filter.codigoCliente = data.codigoCliente;
        this.filter.estadoSolicitudId = data.estadoSolicitudId === 'TODOS' ? '' : data.estadoSolicitudId;
        this.filter.fechaSolicitud = fFechaHora;
        this.obtenerlistaCreditos();
        clearTimeout(this.filterTimer);
      }, 500);
    });
  }

  obtenerlistaCreditos() {
    this.service.obtenerListaCreditos(this.filter)
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.dataSource = data['data'] as any[];
            if (data['pagination']) {
              this.paginacion.actual = +data['pagination'].actual;
              this.paginacion.cantidad = +data['pagination'].cantidad;
              this.paginacion.por_pagina = +data['pagination'].por_pagina;
              this.paginacion.total = +data['pagination'].total;
            }
          } else {
            this.dataSource = [];
            this.paginacion = {
              actual: 1,
              cantidad: 1,
              por_pagina: 10,
              total: 1
            };
          }
          //this.snackbar.noMessage();
        });

  }

  /**
   * Funcion para obtener la lista de estados de solicitudes de crédito existentes
   */
  obtenerListaEstadoSolicitudCredito() {
    this.service.obtenerListaEstaddoSolicitudCredito()
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.estadoList = [...[{id: '', nombre: 'TODOS'}], ...data['data']];
          } else {
            this.estadoList = [];
          }
          //this.snackbar.noMessage();
        });
  }

  public obtenerDatos(event?: PageEvent) {
    let pagina = 1;
    pagina = event.pageIndex + 1;
    if (event.pageIndex === 0 && event.previousPageIndex === 1) {
      pagina = 1;
    }
    this.filter.cantidadPagina = event.pageSize;
    this.filter.pagina = pagina;
    this.obtenerlistaCreditos();
    return event;
  }

  exportar() {
    let fechaHora: Date;
    let fechaCompra = '';
    if(this.formFilter.controls.fechaSolicitud.value){
      fechaHora = new Date(this.formFilter.controls.fechaSolicitud.value);
      fechaCompra = (fechaHora.getMonth() < 9 ? '0' : '-') + (fechaHora.getMonth()+1) + (fechaHora.getDate() < 10 ? '-0' : '-')  + fechaHora.getDate() +'-'+ fechaHora.getFullYear();
    }


    const nombre =
      'reporte_solic_cretidos_' + fechaCompra;

    const data = {
      nombre: this.filter.nombre,
      apellido: this.filter.apellido,
      comercio: this.filter.comercio,
      estadoSolicitudId: this.filter.estadoSolicitudId,
      fechaSolicitud: fechaCompra,
      entidad: this.filter.entidad,
      cantidadPagina: this.filter.cantidadPagina,
      pagina: 0,
    };
    console.log(data);
    this.service.obtenerListaCreditos(data).subscribe((res: any) => {
      if (!(res instanceof Array)) {
        this.snackbar.showMessage(
          `Reporte generado, ${res.data.length} registros`,
          'success',
          2000
        );
        this.csvService.downloadFile(
          res.data,
          [
            'id',
            'comercio',
            'nombre',
            'apellido',
            'codigoCliente',
            'estadoSolicitud',
            'numeroSolicitud',
            'montoSolicitado',
            'plazoMeses',
            'importeCuota',
            'mensajeAprobadoRechazado',
            'montoDesembolsado',
            'fechaSolicitud'
          ],
          nombre
        );
      } else {
        this.snackbar.showMessage(
          'No se encontraron datos en el rango de fechas',
          'warning',
          2000
        );
      }
    });

  }

  ver(e: Fraccionamiento) {
    // se agrega el registro como parametro de navegacion
 /*   const extra: NavigationExtras = {
      state: e
    };*/
    //if(e){
      delete e['full_count'] //removemos el atributo full_count
    //}
    console.log('ver',e)
    e['cliente'] = e.nombre + ' ' + e.apellido
    this.service.setItem(e);
    this.router.navigate(['procesadora/fraccionamiento/ver']);

  }

  modificar(e: Fraccionamiento) {
    //if(e){
      e['cliente'] = e.nombre + ' ' + e.apellido
      delete e['full_count'] //removemos el atributo full_count
    //}
    this.service.setItem(e);
    this.router.navigate(['procesadora/fraccionamiento/modificar'])
  }
}
